import Caption from "./Caption";
import Headline from "./Headline";
import Paragraph from "./Paragraph";
import Subheading from "./Subheading";
import Text from "./Text";
import Title from "./Title";

export {
    Text as default,
    Caption,
    Headline,
    Paragraph,
    Subheading,
    Title,
};
